class InquiryGroupItem {
  constructor() {
    this.id = Date.now();
    this.price_per_month = 0;
    this.price_one_time = 0;
    this.item_name = "";
    this.item_type = "";
    this.quantity = 1;
    this.vat = 0;
    this.currency = "EUR";
    this.is_device = false;
    this.kpi_type = "";
    this.exact_code_id = null;
    this.billing_item_id = null;
  }
}

export default InquiryGroupItem;
